import { FC } from 'react'
import ProductsList from '../../modules/products/ProductsList'

interface Props {
  readOnly?: boolean
}

const ProductsListPage: FC<Props> = ({readOnly = false}) => {
  return (
    <>
      {/* begin::Row */}
      <div className='row g-5 g-xl-10 mb-5 mb-xl-10'>
      {/* begin::Col */}
      <div className='col-md-12 col-lg-12 mb-md-5 mb-xl-10'>
          <ProductsList />
          {/* TODO: Add read-only mode support to ProductsList component */}
      </div>
      {/* end::Col */}
      </div>
      {/* begin::Row */}
    </>
  )
}

export default ProductsListPage